import SpaSoft from './spa-soft/spa-soft.vue'
import SpaReservationDetails from './spa-reservation-details/spa-reservation-details.vue'

export {
  SpaSoft,
  SpaReservationDetails,
}
